<template>
  <tr>
    <td>{{ name | stringPlaceholder }}</td>
    <td>{{ login | stringPlaceholder }}</td>
    <td>
      <template v-if="isAdmin">
        <SvgIcon
          :svg="require('!svg-inline-loader?classPrefix!@mdi/svg/svg/check.svg')"
          :size="24"
        />
      </template>
      <template v-else>
        <SvgIcon
          :svg="require('!svg-inline-loader?classPrefix!@mdi/svg/svg/close.svg')"
          :size="24"
        />
      </template>
    </td>
    <td>
      <Button @click="$emit('edit', user)">更改</Button>
    </td>
  </tr>
</template>

<script>
import SvgIcon from '@/components/SvgIcon'
import Button from '@/components/Button'
import Input from './Input'

export default {
  components: {
    SvgIcon,
    Button,
    Input,
  },
  props: {
    user: {
      required: true,
      type: Object,
    },
  },
  computed: {
    name () {
      return this.user.name
    },
    login () {
      return this.user.login
    },
    isAdmin () {
      return this.user.role == 'ADMIN'
    },
  },
  filters: {
    stringPlaceholder (val) {
      return val || '-'
    },
  },
}
</script>
